import React from 'react';

import { cssMap } from '@atlaskit/css';
import Lozenge, { type NewLozengeProps } from '@atlaskit/lozenge';
import { Inline } from '@atlaskit/primitives/compiled';
import type { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { ActionRendererKeyToPayload } from '@atlassian/conversation-assistant-message-actions-api/types';

export type Payload = ActionRendererKeyToPayload[typeof ActionKeys.CreateProjectProgressUpdate];

const styles = cssMap({
	container: {
		display: 'inline-flex',
		alignItems: 'center',
	},
});

export const StatusField = ({
	statusLozengeText,
	statusLozengeAppearance,
}: {
	statusLozengeText?: string;
	statusLozengeAppearance?: NewLozengeProps['appearance'];
}): React.JSX.Element | null => {
	if (!statusLozengeText) {
		return null;
	}

	return (
		<Inline xcss={styles.container} testId="project-status-update-action-renderer.ui.status">
			<Lozenge appearance={statusLozengeAppearance} isBold>
				{statusLozengeText}
			</Lozenge>
		</Inline>
	);
};
